import React, { useEffect, useReducer } from 'react';
import cn from 'classnames';
import { Button } from '@UILayer/Inputs/Button';
import { useTranslation } from 'react-i18next';

// TYPES
import { IStateType, stateDefault } from './HistoryCheck.types';
import { EDelegatedPages } from '@Managers/PopClient/UsePopClient.types';
import { TPopClientFeatures } from '@ConfigLoader/Configs';

// MANAGERS
import httpService from '@Services/HttpService/HttpService';
import ConfigLoader from '@ConfigLoader/ConfigLoader';
import { useAppDispatch, useAppSelector } from '@Managers/Redux/Hooks';
import { getCasinoMenu, getPopClient, setInGameHistoryPage, setMenuPages } from '@Managers/Redux/AppState/AppState';
import EventsCenter from '@Managers/Events/EventsCenter';
import { EGameEvents } from '@Managers/Events/GameEvents';

// STYLES
import styles from '@UILayer/UILayer.scss';

// IMAGES
import historyIcon from './icon_history.svg';

import { DOM_ID } from '@UILayer/UILayer.types';

const HistoryCheck: React.FC = () => {
    const [state, setState] = useReducer((state: IStateType, newState: {}) => ({ ...state, ...newState }), stateDefault);

    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const casinoData = useAppSelector(getCasinoMenu);
    const popClientconfig = useAppSelector(getPopClient);

    async function userHistoryCheck() {
        if (state.historyReqest && !state.historyReqestPending) {
            setState({ historyReqestPending: true, text: t('CHECK_GAMEPLAY_HISTORY_STATE_PENDING') });
            const historyData = (await httpService.historyRequest()) as any;

            if (historyData && historyData.url) {
                setState({ showHistoryCheck: true, historyReqest: true, text: t('CHECK_GAMEPLAY_HISTORY_BUTTON'), historyReqestPending: false });
                dispatch(setInGameHistoryPage({ active: true, url: historyData.url }));
            }
        } else {
            const popClient = popClientconfig.enabled;
            const available = popClientconfig.supportedFeatures[TPopClientFeatures.OPEN_PAGE]?.delegatePages?.includes(EDelegatedPages.GAME_HISTORY)
                ? true
                : false;

            if (popClient && available) {
                EventsCenter.emit(EGameEvents.OPEN_PAGE, {
                    pageID: EDelegatedPages.GAME_HISTORY,
                    url: casinoData.history?.url
                });
            } else {
                window.open(casinoData.history?.url, '_blank');
            }
        }
    }

    useEffect(() => {
        if (casinoData.history) {
            setState({ showHistoryCheck: true, text: t('CHECK_GAMEPLAY_HISTORY_BUTTON') });
        }
        if (ConfigLoader.connectionConfiguration.gateways.history) {
            setState({ showHistoryCheck: true, historyReqest: true, text: t('CHECK_GAMEPLAY_HISTORY_BUTTON') });
        }
    }, [casinoData]);

    return (
        <>
            {state.showHistoryCheck && (
                <div className={cn(styles.settings_item, styles.settings_button_group)}>
                    <div className={cn(styles.settings_item_label, styles.checkbox_label)}>
                        <label id={DOM_ID.SETTINGS_HISTORY_CHECK_LABEL}>{t('CHECK_GAMEPLAY_HISTORY_LABEL')}</label>
                    </div>
                    <div className={cn(styles.settings_item_button)}>
                        <Button
                            id={DOM_ID.SETTINGS_HISTORY_CHECK_BUTTON}
                            description={`${t('CHECK_GAMEPLAY_HISTORY_LABEL')} ${state.text}`}
                            className={cn(styles.settings_button, styles.settings_button_history, state.historyReqestPending ? styles.disabled : false)}
                            onChange={userHistoryCheck}
                        >
                            {state.historyReqestPending ? (
                                <div className={styles.history_loader} />
                            ) : (
                                <img src={historyIcon} alt={`${t('CHECK_GAMEPLAY_HISTORY_LABEL')} ${state.text}`} />
                            )}
                            {state.text}
                        </Button>
                    </div>
                </div>
            )}
        </>
    );
};

export default HistoryCheck;
